/**
 * DOM / app.js refresh diagnostics — enable with ?usipic_trace=1 (or ?usipic_debug=1)
 * Does NOT mutate DOM (unlike usipic_debug debug panel).
 */
(function () {
  'use strict';

  function traceEnabled() {
    try {
      var q = String(window.location.search || '');
      return /(?:^|[?&])usipic_trace=1(?:&|$)/.test(q) || /(?:^|[?&])usipic_debug=1(?:&|$)/.test(q);
    } catch (e) {
      return false;
    }
  }

  if (!traceEnabled()) return;

  var TAG = '[USIPIC trace]';
  var bootWrapAttempts = 0;
  var maxBootWrapAttempts = 200;
  var counts = {
    boot: 0,
    remountNav: 0,
    loadBundle: 0,
    safeBootScript: 0,
    moBody: 0,
    moNavbar: 0,
    moPoster: 0,
    reload: 0
  };

  function shortStack() {
    try {
      return new Error().stack.split('\n').slice(2, 6).join(' | ');
    } catch (e) {
      return '';
    }
  }

  function log(event, detail) {
    if (!window.console || typeof console.log !== 'function') return;
    try {
      console.log(TAG, event, detail || {}, shortStack());
    } catch (e2) {}
  }

  log('enabled', {
    href: String(window.location.href || '').slice(0, 200),
    usipic_debug_in_url: /(?:^|[?&])usipic_debug=1(?:&|$)/.test(String(window.location.search || '')),
    usipic_trace_in_url: /(?:^|[?&])usipic_trace=1(?:&|$)/.test(String(window.location.search || '')),
    note: 'usipic_debug is NOT default — only active when URL contains the param'
  });

  window.addEventListener('beforeunload', function () {
    counts.reload += 1;
    log('beforeunload', { reloadCount: counts.reload });
  });

  function getPendingSignature() {
    var pendingSections = document.querySelectorAll('[data-new-usipic-section]:not([data-new-usipic-mounted="1"])').length;
    var pendingNav = document.querySelectorAll('#new-usipic-navbar-root:not([data-nav-ready="1"])').length;
    return pendingSections + ':' + pendingNav;
  }

  function wrapFn(name) {
    var fn = window[name];
    if (typeof fn !== 'function' || fn.__usipicTraced) return false;
    var original = fn;
    window[name] = function usipicTracedHook() {
      if (name === '__NEW_USIPIC_BOOT__') counts.boot += 1;
      if (name === '__NEW_USIPIC_REMOUNT_NAV__') counts.remountNav += 1;
      log('app.js:' + name, {
        call: name === '__NEW_USIPIC_BOOT__' ? counts.boot : counts.remountNav,
        pending: getPendingSignature(),
        navReady: !!document.querySelector('#new-usipic-navbar-root[data-nav-ready="1"]')
      });
      return original.apply(this, arguments);
    };
    window[name].__usipicTraced = true;
    log('hooked', { fn: name });
    return true;
  }

  function tryWrapAppHooks() {
    var a = wrapFn('__NEW_USIPIC_BOOT__');
    var b = wrapFn('__NEW_USIPIC_REMOUNT_NAV__');
    if (a || b) log('app-hooks-ready', counts);
    bootWrapAttempts += 1;
    if ((!window.__NEW_USIPIC_BOOT__ || !window.__NEW_USIPIC_REMOUNT_NAV__) && bootWrapAttempts < maxBootWrapAttempts) {
      setTimeout(tryWrapAppHooks, 250);
    }
  }

  if (typeof window.__NEW_USIPIC_LOAD_BUNDLE__ === 'function' && !window.__NEW_USIPIC_LOAD_BUNDLE__.__usipicTraced) {
    var loadBundle = window.__NEW_USIPIC_LOAD_BUNDLE__;
    window.__NEW_USIPIC_LOAD_BUNDLE__ = function (reason) {
      counts.loadBundle += 1;
      log('NEW-app-script:loadBundle', { n: counts.loadBundle, reason: reason || '' });
      return loadBundle.apply(this, arguments);
    };
    window.__NEW_USIPIC_LOAD_BUNDLE__.__usipicTraced = true;
  }

  function watchMutations(label, node, bucket) {
    if (!node || typeof MutationObserver === 'undefined') return;
    var n = 0;
    var lastLog = 0;
    var obs = new MutationObserver(function (records) {
      counts[bucket] += records.length;
      n += records.length;
      var now = Date.now();
      if (now - lastLog > 800) {
        lastLog = now;
        log('MutationObserver:' + label, {
          burst: n,
          total: counts[bucket],
          pending: getPendingSignature()
        });
        n = 0;
      }
    });
    obs.observe(node, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  function startWatchers() {
    watchMutations('body', document.body, 'moBody');
    watchMutations('navbar', document.getElementById('new-usipic-navbar-root'), 'moNavbar');
    watchMutations('poster', document.getElementById('usipic-poster-app'), 'moPoster');
  }

  tryWrapAppHooks();
  if (document.body) startWatchers();
  else document.addEventListener('DOMContentLoaded', startWatchers, { once: true });

  setInterval(function () {
    log('heartbeat', {
      counts: counts,
      pending: getPendingSignature(),
      appLoaded: !!window.__NEW_USIPIC_SCRIPT_LOADED__,
      posterInit: !!(document.getElementById('usipic-poster-app') && document.getElementById('usipic-poster-app').getAttribute('data-usipic-init') === '1')
    });
  }, 5000);

  window.__USIPIC_DOM_TRACE__ = {
    counts: counts,
    getPendingSignature: getPendingSignature,
    log: log
  };
})();
